import * as React from "react";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator
} from "@mui/lab";
import { Divider, Typography } from "@mui/material";
import { CircleIcon } from "@primer/octicons-react";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import styles from "./medical-records.module.scss";
import useAssessments from "../../../common/hooks/useMedicalRecords";
import Spinner from "../../../common/components/spinner";
import medicalRecordStyles from "./medical-records-style";
import { opdDurationFormatter } from "../../../../containers/Reports/PatientAssessments";
import AssessmentInfoPanel from "../../../../containers/Assessment/AssessmentInfoPanel";
import { AssessmentDocument } from "../../../../interfaces/AssessmentInterfaces";
import NoDataView from "../../../common/components/no-data-view/no-data-view";

const MedicalRecords = (): React.JSX.Element => {
  const { isLoading, assessments } = useAssessments();
  const [selectedAssessment, setSelectAssessment] = React.useState<AssessmentDocument | null>(null);
  if (isLoading) return <Spinner />;
  return (
    <div className={styles.medicalRecordsContainer}>
      {Object.keys(assessments).length === 0 ? (
        <NoDataView />
      ) : (
        Object.keys(assessments).map((key) => {
          const mapKey = key;
          return (
            <Timeline sx={medicalRecordStyles.timeLine} key={mapKey}>
              <TimelineItem>
                <TimelineSeparator>
                  <TimelineDot variant="filled" className={styles.timelineDot}>
                    <CircleIcon className={styles.circleIcon} />
                  </TimelineDot>
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent className={styles.headerContent}>{key}</TimelineContent>
              </TimelineItem>
              {assessments[key].map((assessment) => {
                const { id, assessmentDocument } = assessment;
                const sp = assessmentDocument.serviceProvider;
                const spName = `${sp.title} ${sp.firstName} ${sp.lastName}`;
                return (
                  <TimelineItem key={id} className={styles.medical}>
                    <TimelineSeparator>
                      <TimelineDot variant="outlined" className={styles.dotBorder}>
                        <LibraryBooksIcon />
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent
                      className={styles.content}
                      onClick={() => setSelectAssessment(assessment)}
                    >
                      <Typography>{spName}</Typography>
                      <Divider
                        className={styles.divider}
                        orientation="vertical"
                        variant="middle"
                        flexItem
                      />

                      <Typography>
                        {opdDurationFormatter(assessmentDocument.opdDuration)}
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                );
              })}
            </Timeline>
          );
        })
      )}

      {selectedAssessment && (
        <AssessmentInfoPanel
          onClose={() => setSelectAssessment(null)}
          assessment={selectedAssessment}
          disableCarryForward
        />
      )}
    </div>
  );
};
export default MedicalRecords;
